import { withCommon } from '@/services/translation/commonTranslations';
import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {
    myProfile: {
      header: 'My Profile',
      editLabel: 'Edit Profile',
      editHeader: 'Edit My Profile'
    },
    myCalendar: {
      header: 'Calendar',
      tasks: (count: number) => `${count} ${count === 1 ? 'TASK' : 'TASKS'}`,
      viewRoster: 'View Roster',
      viewShiftDetails: 'View Shift Details',
      setAvailability: 'Set Availability',
      cancel: 'Cancel'
    },
    myAvailability: {
      header: 'Availability',
      availabilityLeaveType: 'Availability/Leave Type',
      availabilityStartTime: 'Availability Start Time',
      availabilityEndTime: 'Availability End Time'
    },
    mySchedule: {
      header: 'Schedule',
      editLabel: 'Edit Availability Schedule',
      cardTitle: 'Preferred Schedule',
      notAvailable: 'Not available',
      dayLabels: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
      }
    },
    viewRoster: {
      header: 'Roster'
    },
    viewShiftDetails: {
      header: 'Shift Details',
      breakLabel: 'Break Time',
      shiftStart: 'Shift Start',
      shiftEnd: 'Shift End'
    },
    role: 'Role',
    personalInformation: 'Personal Information'
  }
});

export default withCommon<typeof strings>(strings);
